import React, { useState, useEffect } from 'react';
import "./OrientationWarning.css";
const OrientationWarning = () => {
    const [isLandscape, setIsLandscape] = useState(false);

    useEffect(() => {
        // Initial check
        checkOrientation();

        // Listen for orientation changes
        window.addEventListener('resize', checkOrientation);
        window.addEventListener('orientationchange', checkOrientation);

        return () => {
            window.removeEventListener('resize', checkOrientation);
            window.removeEventListener('orientationchange', checkOrientation);
        };
    }, []);

    const checkOrientation = () => {
        setIsLandscape(window.innerWidth > window.innerHeight);
    };

    if (!isLandscape) return null;

    return (
        <div className="orientation-overlay">
            <div className="orientation-modal">
                <div className="orientation-content">
                    <h2>Please Rotate Your Device</h2>
                    <p>This app works best in portrait mode. Please rotate your device to continue.</p>
                </div>
            </div>
        </div>
    );
};

export default OrientationWarning;